import { useState } from 'react';

export const AnimatedCard = ({ children, className = '', enableHover = true }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (e) => {
    if (!enableHover) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <div
      className={`group relative ${className}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Blue line border on hover - same as Trading Guide */}
      <div className="absolute -inset-[1px] bg-gradient-to-r from-[hsl(210,100%,56%)] via-[hsl(190,95%,55%)] to-[hsl(210,100%,56%)] rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      
      {/* Main content - same style as Trading Guide */}
      <div className="relative rounded-2xl transition-all duration-300 bg-white border border-gray-200 shadow-[0_4px_20px_rgba(0,0,0,0.08)] group-hover:border-[hsl(210,100%,60%)]/60 dark:bg-[hsl(220,18%,13%)] dark:border-[hsl(210,100%,60%)]/30 dark:shadow-none dark:group-hover:border-[hsl(210,100%,60%)]/70">
        <div className="relative z-10">
          {children}
        </div>
      </div>
    </div>
  );
};
